import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { RoleForm } from './forms/RoleForm';
import { useTeamStore } from '../../stores/teamStore';
import { Role } from '../../types/user';
import { ar } from '../../locales/ar';
import toast from 'react-hot-toast';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  role: Role;
};

export const EditRoleModal = ({ isOpen, onClose, role }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { updateRole } = useTeamStore();

  const handleSubmit = async (data: Partial<Role>) => {
    setIsLoading(true);
    setError('');

    try {
      await updateRole(role.id, {
        ...data,
        updatedAt: Date.now()
      });
      toast.success(ar.roles.messages.updateSuccess);
      onClose();
    } catch (err: any) {
      setError(err.message || ar.roles.messages.updateError);
      toast.error(ar.roles.messages.updateError);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={ar.roles.form.title.edit}>
      {error && (
        <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
          {error}
        </div>
      )}
      <RoleForm
        onSubmit={handleSubmit}
        initialData={role}
        isLoading={isLoading}
      />
    </Modal>
  );
};